/* istanbul ignore next */

import { UrlFragments } from 'app/constants';

export const REACT_APP_API_URL = process.env.VITE_API_URL;
export const REACT_APP_AUTH0_DOMAIN = process.env.VITE_AUTH0_DOMAIN;
export const REACT_APP_AUTH0_CLIENT_ID = process.env.VITE_AUTH0_CLIENT_ID;
export const REACT_APP_AUTH0_SCOPES = process.env.VITE_AUTH0_SCOPES;
export const REACT_APP_AUTH0_AUDIENCE = process.env.VITE_AUTH0_AUDIENCE;
export const REACT_APP_LOG_SOURCE_CATEGORY =
  process.env.VITE_LOG_SOURCE_CATEGORY;
export const REACT_APP_LOG_PROXY_ENDPOINT = process.env.VITE_LOG_PROXY_ENDPOINT;
export const REACT_APP_IS_SIEMENS_BRANDING_URL =
  process.env.VITE_IS_SIEMENS_BRANDING_URL;

export const REACT_APP_SIEMENS_API_URL = process.env.VITE_SIEMENS_API_URL;
export const REACT_APP_AUTH0_SIEMENS_SETTINGS =
  process.env.VITE_AUTH0_SIEMENS_SETTINGS;

const {
  user: { all_users, user_company },
  subscription: { all_subscription },
  portfolio: { all_pfs },
  company: {
    all_companies,
    sso_connection_type,
    upload_sso_config,
    download_sso_config,
  },
} = UrlFragments;

export const API_ENDPOINTS = {
  USERS: `/${all_users}`,
  USER: `/${all_users}/`,
  USER_COMPANY: `/${user_company}`,
  SUBSCRIPTION: `/${all_subscription}/`,
  SUBSCRIPTIONS: `/${all_subscription}`,
  PORTFOLIOS: `/${all_pfs}`,
  PORTFOLIO: `/${all_pfs}/`,
  COMPANIES: `/${all_companies}`,
  COMPANY: `/${all_companies}/`,
  SSO_CONNECTION_TYPE: `/${sso_connection_type}`,
  UPLOAD_SSO_CONFIG: `/${upload_sso_config}`,
  DOWNLOAD_SSO_CONFIG: `/${download_sso_config}`,
};
